/**
 * Maps backend error codes (APP_LABEL.ERROR_TYPE.ERROR_ID) to i18n keys so
 * user-facing toasts are translated instead of showing raw backend strings.
 *
 * Add new entries here as backend raises new typed AppExceptions that need
 * friendly/localized UI copy.
 */
export const ERROR_CODE_I18N_MAP: Record<string, string> = {
  'TEAM.VAL.035': 'common:invites.alreadyMember',
}
